module.exports = __webpack_public_path__ + "img/max-register-step-1.fe39c8a4.png";